import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { message } from 'antd';
import ColorBox from './components/ColorBox';
import ChartBox from './components/ChartBox';
import ColorFilter from './components/ColorFilter';
import ChartFilter from './components/ChartFilter';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import ExportModal from './components/ExportModal'
import { colorBox, chartBox, ColorParams, ChartParams } from '../constants/finance';

const FinExportType = {
    financeIncome: 'FinanceAnalysis',
    centerIncome: 'InvSiteAnalysis',
    request: 'RemittanceAnalysis',
};

class Dashboard extends Component {
    static contextTypes = {
        activeKey: PropTypes.string,
        systemDate: PropTypes.object,
        isSeniorUserBo: PropTypes.bool,
        FINANCE_INDICATOR_ANALYSIS: PropTypes.bool,
        isDesignatedTal: PropTypes.bool,
        isLineCharge: PropTypes.bool,
    }

    constructor(props, context) {
        super(props);
        const { activeKey, systemDate, isSeniorUserBo, FINANCE_INDICATOR_ANALYSIS, isDesignatedTal, isLineCharge } = context;
        // 判断是否仅满足 isDesignatedTal=true（需要自动填充领域leader）
        const curRole = sessionStorage.curRole;
        const needAutoFill = isDesignatedTal && curRole !== 'FIN' && !isSeniorUserBo && !FINANCE_INDICATOR_ANALYSIS && !isLineCharge;

        const colorParams = {...ColorParams[activeKey]};
        colorParams.date = systemDate.monthDate;
        const chartParams = {...ChartParams[activeKey]};
        chartParams.year = systemDate.trueYear;
        this.state = {
            refreshColor: null,
            refreshChart: null,
            colorParams,
            chartParams,
            colorBoxReady: !needAutoFill, // 需要自动填充时先不渲染ColorBox
            chartBoxReady: !needAutoFill, // ChartBox同理
        };
    }

    componentDidMount() {
        // 当仅满足 isDesignatedTal=true 时，自动填充当前登录人为领域leader
        const curRole = sessionStorage.curRole;
        const { isSeniorUserBo, FINANCE_INDICATOR_ANALYSIS, isDesignatedTal, isLineCharge } = this.context;
        const onlyDesignatedTal = isDesignatedTal && curRole !== 'FIN' && !isSeniorUserBo && !FINANCE_INDICATOR_ANALYSIS && !isLineCharge;

        if (onlyDesignatedTal) {
            const { userId } = sessionStorage;
            Fetch.post(API_URL.user.queryLeaderList, { userId, status: 'WORKING' }).then(res => {
                const { datas = [] } = res;
                if (datas.length > 0) {
                    const user = datas[0];
                    const talUserId = user.userId;
                    const talUserName = user.employeeCode ? `${user.userCompellation}[${user.employeeCode}]` : user.userCompellation;
                    // 同时更新colorParams和chartParams，确保两种图表首次加载即携带leader过滤条件
                    this.setState({
                        colorParams: { ...this.state.colorParams, talUserId, talUserName },
                        chartParams: { ...this.state.chartParams, talUserId, talUserName },
                        colorBoxReady: true,
                        chartBoxReady: true,
                    });
                }
            });
        }
    }

    exportModalShow = type => {
        this.exportModalRef.show(type)
    }

    handleExport = ( type, value = []) => {
        const { activeKey } = this.context;
        const params = this.state[`${type}Params`];
        const { areaParams, statisticDate, hasCheckedArea, investigationMedicineType = [], ...rest } = params;
        const statisticsType = type === 'color' ? 'Color' : 'Graph';
        const detailType = activeKey == 'request'?'RemittanceAnalysis':value.join(',');
        Fetch.post(API_URL.dashboard.exportFinanceAnalysis, {
            ...rest,
            ...areaParams,
            investigationMedicineType: investigationMedicineType[0],
            secondResearchProductType: investigationMedicineType[1],
            statisticsType,
            detailType,
        }).then(res => {
            message.success(res.success);
        });
    }

    handleSearch = (type) => {
        this.setState({ [`refresh${type.replace(/^\w/, m => m.toUpperCase())}`]: {} });
    }

    handleChange = (value, type) => {
        this.setState({ [`${type}Params`]: value });
    }

    render() {
        const { activeKey } = this.context;
        const { colorParams, refreshColor, chartParams, refreshChart, colorBoxReady, chartBoxReady } = this.state;
        console.log(activeKey);
        return (
            <div>
                <ColorFilter
                    params={colorParams}
                    onExport={() => activeKey !== 'request' ?  this.exportModalShow('color') : this.handleExport('color')}
                    onSearch={() => this.handleSearch('color')}
                    onChange={value => this.handleChange(value, 'color')}
                />
                <div className={(activeKey == 'centerIncome' || activeKey == 'request') ? "specialColorWrap" : "colorWrap"}>
                    {
                        colorBoxReady && colorBox[activeKey].map(item => {
                            return (
                                <ColorBox
                                    {...item}
                                    key={item.moduleType}
                                    params={colorParams}
                                    refresh={refreshColor}
                                />
                            );
                        })
                    }
                </div>
                <ChartFilter
                    params={chartParams}
                    onExport={() => activeKey !== 'request' ?  this.exportModalShow('chart') : this.handleExport('chart')}
                    onSearch={() => this.handleSearch('chart')}
                    onChange={value => this.handleChange(value, 'chart')}
                    subTabActiveKey={this.props.subTabActiveKey}
                />
                <div className="flexBox">
                    {
                        chartBoxReady && chartBox[activeKey].map(item => {
                            return (
                                <ChartBox
                                    {...item}
                                    key={item.moduleType}
                                    params={chartParams}
                                    refresh={refreshChart}
                                />
                            );
                        })
                    }
                </div>
                <ExportModal activeKey={activeKey} ref={ el => this.exportModalRef = el } export={this.handleExport}/>
            </div>
        );
    }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/homePage/FinanceIndicatorAnalysis/Dashboard.js